/**
 * API에서는 별도의 Vo로 관리하고 있지 않으나, 알림 타입 관리의 용이성을 위해 임의로 추가해준 Enum Vo입니다.
 * 참고: https://github.kakaocorp.com/kakaopage/api/blob/0593087390ad49c5a57a7007a4ae1e1e9ad8e326/mysql/src/main/java/com/kakaopage/mysql/pagecontents/entity/api/UserNotificationVO.java#L30
 */

export enum NotiTypeVo {
  // 시리즈 업데이트 알림
  U = 'U',
  // 공지사항 알림
  N = 'N',
  // 이벤트 알림
  E = 'E',
  // 선물 알림
  G = 'G',
  // 이용권 선물 푸시
  T = 'T',
  // 기타 마케팅 푸시
  M = 'M',
  // 캐시프렌즈 광고
  C = 'C',
  // 좋아요 알림
  L = 'L',
  // 대댓글 알림
  R = 'R',
  // 친구 선물, 선물무
  F = 'F',
  // 뽑기권 알림
  A = 'A',
  // 캐시 알림
  P = 'P',
}
